import { render } from "./PetronelaPascaruPage.vue?vue&type=template&id=0cca7bf6"
import script from "./PetronelaPascaruPage.vue?vue&type=script&lang=js"
export * from "./PetronelaPascaruPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__